import styled from 'styled-components';

export const ArticleHeading = styled.h3`
  font-weight: 500;
  font-size: 15px;
  color: #000c;
  border-bottom: 1px solid rgb(0 0 0 / 10%);
  padding: 0 0 8px 12px;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    width: 3px;
    height: 16px;
    background: hsl(174deg 33% 54% / 36%);
  }
`;

export const ArticleList = styled.ul`
  &::-webkit-scrollbar {
    width: 0;
    transition: all 0.3s ease;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
  }
  &::-webkit-scrollbar-track {
    background-color: #fff;
  }

  &:hover {
    &::-webkit-scrollbar {
      width: 3px;
    }
  }
  padding: 14px 0 14px 36px;
  min-height: max-content;
  max-height: 280px;
  overflow-y: auto;

  li {
    font-size: 14px;
    font-weight: 400;
    color: hsl(0deg, 0%, 0%, 80%);
    padding: 10px 0;
    cursor: pointer;
    opacity: 0.85;

    &:hover {
      font-weight: 600;
      position: relative;

      &:before {
        content: '';
        position: absolute;
        left: -13px;
        width: 3px;
        height: 16px;
        background: hsl(0deg 0% 0% / 30%);
      }
    }

    &.selected {
      font-weight: 600;
      position: relative;

      &:before {
        content: '';
        position: absolute;
        left: -13px;
        width: 3px;
        height: 16px;
        background: hsl(0deg 0% 0% / 30%);
      }
    }
  }
`;
